export class FetchUserSubscriptionInvoicesAction {
  static readonly type = '[Payment] Fetch User Subscription Invoices';

  constructor() {
  }
}
